import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

function resetLastActiveSeparator(ac: ActionCard) {
  const isLastActiveSeparatorEnabled = !!ac.enabledSeparators?.some(sepId => sepId === ac.lastActiveSeparator)

  if (isLastActiveSeparatorEnabled) {
    return
  }

  const lastEnabledSeparator = ac.enabledSeparators?.at(-1)

  if (lastEnabledSeparator) {
    ac.lastActiveSeparator = lastEnabledSeparator
  } else {
    ac.lastActiveSeparator = -1
  }

  return
}

export default resetLastActiveSeparator
